import { defHttp } from "../utils/http/axios";

const Api = {
    getMonoATEEngines: "/corpus/ate/engine/mono/list",
    state: "/corpus/ate/state",
    ateInfo: "/corpus/ate/info",
    projectInfo: "/corpus/ate/project/info",
    terms: "/corpus/ate/terms",
    saveAte: "/corpus/ate/save",
    saveprojectAte: "/corpus/ate/project/save",
}

/**
 * 获取单语(monolingual)术语提取引擎列表
 * @param {*} params
 * @returns
 */
export function getMonoATEEngines(params) {
    return defHttp.get({ url: Api.getMonoATEEngines, params })
}
/**获取ATE的提取状态*/
export  function queryATEState(params){
    return defHttp.get({url: Api.state, params});
}
/**获取ATE信息*/
export  function queryATEInfo(params){
    return defHttp.get({url: Api.ateInfo, params});
}
/**获取ATE项目信息*/
export  function queryATEInfoByProjectId(params){
    return defHttp.get({url: Api.projectInfo, params});
}
/**保存ATE项目用户编辑信息*/
export  function saveATE(params) {
    return defHttp.post({url: Api.saveATE, params});
}
/**保存ATE项目用户编辑信息*/
export  function saveATEByProject(params) {
    return defHttp.post({url: Api.saveprojectAte, params});
}
/** 查询自动提取术语列表*/
export  function queryATETerms(params){
    return defHttp.get({url: Api.terms, params});
}

